import { Banner } from '@fff-web/cms';
import * as styles from './HeroBanner.module.scss';

const HeroBanner = () => {
  return (
    <div className={styles.wrapperBanner}>
      <Banner name="upgrade-to-annual" themeColor="dark" />
    </div>
  );
};

export default HeroBanner;
